export const GETWAREHOUSE_FOR_SHOP_REQUEST = "GETWAREHOUSE_FOR_SHOP_REQUEST";
export const GETWAREHOUSE_FOR_SHOP_SUCCESS = "GETWAREHOUSE_FOR_SHOP_SUCCESS";
export const GETWAREHOUSE_FOR_SHOP_FAILURE = "GETWAREHOUSE_FOR_SHOP_FAILURE";

export const GET_LOCATIONS_FOR_SHOP_REQUEST = "GET_LOCATIONS_FOR_SHOP_REQUEST";
export const GET_LOCATIONS_FOR_SHOP_SUCCESS = "GET_LOCATIONS_FOR_SHOP_SUCCESS";
export const GET_LOCATIONS_FOR_SHOP_FAILURE = "GET_LOCATIONS_FOR_SHOP_FAILURE";
